/**
 * Reviews API Service
 * Handles communication with the /api/reviews endpoints (Saturday 2026-04-25 RAG build).
 *
 * Backend reference: server/app/routes/reviewsRoute.js
 */

import axios from 'axios';

const REVIEWS_API_BASE = 'http://localhost:5050/api/reviews';

/**
 * Submit a new neighborhood review.
 * @param {object} payload — { state, city, neighborhoodName, reviewText, reviewerType, rating?, coordinates? }
 * @returns {Promise<{success, data?, error?}>}
 */
export const submitReview = async (payload) => {
  try {
    const res = await axios.post(REVIEWS_API_BASE, payload, {
      headers: { 'Content-Type': 'application/json' }
    });
    return { success: true, data: res.data };
  } catch (err) {
    // Surface backend's structured error if present, else generic message
    const apiError = err?.response?.data;
    const errorMessage =
      apiError?.details ||
      apiError?.error ||
      err?.message ||
      'Failed to submit review.';
    return {
      success: false,
      error: errorMessage,
      status: err?.response?.status
    };
  }
};

/**
 * Fetch reviews (debug/admin use; deferred /reviews browse page would call this).
 * @param {object} filter — { city?, state?, neighborhood?, onlyUnembedded?, limit? }
 */
export const fetchReviews = async (filter = {}) => {
  try {
    const res = await axios.get(REVIEWS_API_BASE, { params: filter });
    return { success: true, data: res.data };
  } catch (err) {
    return {
      success: false,
      error: err?.response?.data?.error || err?.message || 'Failed to fetch reviews.'
    };
  }
};
